import React from "react";
import MainContentCard from "../../../Home/MainContentCard";
import ErrorBoundaryRoutes from "../../../../components/shared/ErrorBoundaryRoutes";
import AddLocalPurchaseOrderChild from "./AddLocalPurchaseOrderChild";

const AddLocalPurchaseOrder = () => {
  return (
    <MainContentCard>
      <ErrorBoundaryRoutes page="Add LPO" route="/add-lpo">
        <AddLocalPurchaseOrderChild />
      </ErrorBoundaryRoutes>
    </MainContentCard>
  );
};

export default AddLocalPurchaseOrder;
